export const getActionScope = (type = '') =>
    type.split('/')[0].replace(/@/gi, '');
